// models/User.ts
import { Company } from './Company'

export class User {
    id: string
    username: string
    token: string
    displayName: string
    firstName?: string
    lastName?: string
    email: string
    role: string
    profilePath: string
    phoneNumber: string
    isChangePassword: boolean
    homePage: string
    department?: string
    position?: string
    joinDate?: string
    manager?: string
    menuList?: string
    company?: Company

    constructor(
        id: string,
        username: string,
        token: string,
        displayName: string,
        email: string,
        role: string,
        profilePath: string,
        phoneNumber: string,
        isChangePassword: boolean,
        homePage: string,
        firstName?: string,
        lastName?: string,
        department?: string,
        joinDate?: string,
        manager?: string,
        menuList?: string,
        company?: Company,
    ) {
        this.id = id
        this.username = username
        this.token = token
        this.displayName = displayName
        this.email = email
        this.role = role
        this.profilePath = profilePath
        this.phoneNumber = phoneNumber
        this.isChangePassword = isChangePassword
        this.homePage = homePage
        this.firstName = firstName
        this.lastName = lastName
        this.department = department
        this.joinDate = joinDate
        this.manager = manager
        this.menuList = menuList
        this.company = company
    }

    static fromJSON(json: any): User {
        return new User(
            json.id,
            json.username,
            json.token,
            json.displayName,
            json.email,
            json.role,
            json.profilePath,
            json.phoneNumber,
            json.isChangePassword,
            json.homePage,
            json.firstName,
            json.lastName,
            json.department,
            json.joinDate,
            json.manager,
            json.menuList,
            json.company ? Company.fromJSON(json.company) : undefined,
        )
    }
}
